import React from "react";
import "./PromotionRestaurant.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const restaurants = [
  { id: 1, name: "Punnu Biryani", image: "https://katchitimages.blob.core.windows.net/uploads/f51d1600-1569-4b2f-91d5-0e7585a35c53.jpg", address: "Shop 12, C Block, DDA Market,", rating: 4.8 },
  // { id: 2, name: "Lajwaab Banquet", image: "https://katchitimages.blob.core.windows.net/uploads/f51d1600-1569-4b2f-91d5-0e7585a35c53.jpg", address: "Shop 12, C Block, DDA Market,", rating: 4.8 },
  { id: 2, name: "Koshali", image: "https://katchitimages.blob.core.windows.net/uploads/f9ca12f3-fdae-4314-8330-25bf84183c74.jpg", address: "Shop no 27 Private No 3 New Market west patel nagar ", rating: 4.8 },
  { id: 3, name: "Bhaj Radhey Govindam", image: "https://katchitimages.blob.core.windows.net/uploads/0948fe2c-6fc5-41c2-84a1-27852f49ba28.jpg", address: "Main Market, Shakarpur, Delhi, 110092, India", rating: 4.8 },
  { id: 4, name: "Moms kitchen ", image: "https://katchitimages.blob.core.windows.net/uploads/e8c6929c-1775-456e-9c0a-990fe1d35d48.jpg", address: "West Patel Nagar, Patel Nagar, Delhi, 110008, India", rating: 4.8 },
  { id: 5, name: "SaGe Cafe", image: "https://katchitimages.blob.core.windows.net/uploads/4ffe8fc0-c568-4750-8993-d07a46f7fcd6.jpeg", address: "7/5, block 7", rating: 4.8 },
  { id: 6, name: "Kolkata kathi roll", image: "https://katchitimages.blob.core.windows.net/uploads/fbe79c4a-a2c8-4f1a-9ab3-3bcda8cbbf79.jpeg", address: "Site No.07 Community Center Tehbazari Shop,Amar Colony,DEFENCE COLONY, South East, Delhi-110024", rating: 4.8 },
];

const renderStars = (rating) => {
  const full = Math.floor(rating);
  const half = rating - full >= 0.5;
  const stars = [];

  for (let i = 0; i < full; i++) stars.push(<i key={`f${i}`} className="bi bi-star-fill" />);
  if (half) stars.push(<i key="half" className="bi bi-star-half" />);
  for (let i = stars.length; i < 5; i++) stars.push(<i key={`e${i}`} className="bi bi-star" />);

  return stars;
};

export default function PromotionRestaurant() {
  return (
    <section className="promo-restaurant">
      <div className="promo-header">
      <div className="container" data-aos="fade-up">
  <div className="text-center p-3">
    <h1 className="promo-title">Top Rated Restaurant are with us</h1>
    <p className="promo-sub">Top picks near you</p>
  </div>
</div>
      </div>

      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        loop
        speed={600}
        spaceBetween={20}
        breakpoints={{
         320: { slidesPerView: 1 },
  768: { slidesPerView: 2 },
  1024: { slidesPerView: 3 },
  1400: { slidesPerView: 4 },
        }}
      >
        {restaurants.map((r) => (
          <SwiperSlide key={r.id}>
            <article className="promo-card">
              <img
                src={r.image}
                alt={r.name}
                className="promo-img"
                onError={(e) => (e.target.src = "/images/placeholder.png")}
              />

              <div className="promo-info">
                <h3 className="promo-name">{r.name}</h3>
                <p className="promo-address">{r.address}</p>

                <div className="promo-rating">
                  {renderStars(r.rating)}
                  <span className="rating-value">{r.rating.toFixed(1)}</span>
                </div>
              </div>
            </article>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}





// const restaurants = [
//   { id: 1, name: "Rohit Goswami", image: "../assets/team-1.jpeg", address: "123 Main St, City", rating: 4.6 },
//   { id: 2, name: "Naresh Kumar", image: "../assets/team2.jpeg", address: "45 Market Rd", rating: 4.2 },
//   { id: 3, name: "Mr Lorick", image: "../assets/lorick.jpg", address: "12 Ocean Ave", rating: 4.8 },
//   { id: 4, name: "Mukesh Jangra", image: "../assets/muk.jpeg", address: "78 Hill St", rating: 4.4 },
//   { id: 5, name: "Shubham Dhiman", image: "../assets/shub.jpeg", address: "9 Park Lane", rating: 4.1 },
// ];
